import React, { useState} from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { connect } from 'react-redux';
import { passwordRegex } from '../../../assets/constants/strings';
import { resetPass } from '../../../store/User/userActions';
import AuthLoader from '../../Loader/Auth';
import SuccessUI from './Success';

const ResetPasswordForm = ({ email, token, resetPass, user, loading }) => {

  // form data
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState('');
  const [showConf, setShowConf] = useState(false);

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    if (!passwordRegex(password) || password !== confirmPassword) {
      alert(`Password invalid`);
    } else {
      resetPass(email, token, password, confirmPassword);
    }
  };

  const handleInputs = (value, type) => {
    setSubmitted(false);
    if (type === 'password') {
      setPassword(value);
    } else {
      setConfirmPassword(value);
    }
  }

  // todo check if password reset was successful and redirect to login
  if (user && user.success === true) {
    return <SuccessUI />;
  }
  return (
    <React.Fragment>
      <form onSubmit={handleSubmit} className="my-3" autoComplete="off">
        <div className="form-group mb-3 position-relative">
          <input
            className={`form-control${password.length === 0 ? '' : (
              passwordRegex(password) ? ' is-valid' : ' is-invalid'
            )}`}
            placeholder="Password"
            type={showPass ? 'text' : 'password'}
            id="Password"
            onChange={(e) => handleInputs(e.target.value, 'password')}
            value={password}
            required
          />
          {password.length > 0 ? (
            showPass ? (
              <FaEyeSlash className="password-visibility" title="Hide Password" onClick={() => setShowPass(false)} />
            ) : (
              <FaEye className="password-visibility" title="Show Password" onClick={() => setShowPass(true)} />
            )
          ) : null}
          {!loading && user && user.success === false ? (
            <label id="EmailError" className="text-danger mt-1 mb-0">
              *{user.reason}
            </label>
          ) : null}
        </div>
        <div className="form-group position-relative mb-3">
          <input
            className={`form-control${confirmPassword.length === 0 ? '' : confirmPassword === password ? ' is-valid' : ' is-invalid'}`}
            placeholder="Confirm Password"
            type={showConf ? 'text' : 'password'}
            id="ConfirmPassword"
            onChange={(e) => handleInputs(e.target.value, 'conf')}
            value={confirmPassword}
            required
          />
          {confirmPassword.length > 0 ? (
            showConf ? (
              <FaEyeSlash className="password-visibility" title="Hide Password" onClick={() => setShowConf(false)} />
            ) : (
              <FaEye className="password-visibility" title="Show Password" onClick={() => setShowConf(true)} />
            )
          ) : null}
          {submitted &&
            password.length > 0 &&
            confirmPassword.length > 0 && (
              !passwordRegex(password) || confirmPassword !== password
            ) && (
              <label id="EmailError" className="text-danger mt-1 mb-0">
                * Please review your passwords
              </label>
            )}
        </div>
        <b className="mb-3">To create a strong password, use at least 8 characters, 1 Upper case character, 1 digit and 1 special character.</b>
        <button
          disabled={
            !submitted &&
            password.length > 0 &&
            confirmPassword.length > 0 && (
              !passwordRegex(password) || confirmPassword !== password
            )
          }
          type="submit"
          className="smaller">
          {loading ? 'Loading' : `Save`}{loading ? <AuthLoader /> : null}
        </button>
      </form>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  loading: state.user.loading
});

const mapDispatchToProps = { resetPass };

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);
